import {z} from '@hono/zod-openapi';

export const imageGenerationResponseSchema = z
  .object({
    // Base64-encoded PNG.
    image: z.string(),
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    revisedPrompt: z.string().nullable(),
  })
  .openapi('ImageGenerationResponse');

export type ImageGenerationResponse = z.infer<typeof imageGenerationResponseSchema>;
